import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

import { IpRoleService } from '../services/ip-role.service';
import { IpAuthService } from '../services/ip-auth.service';
import { IpProfileService } from '../services/ip-profile.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private ipRoleService: IpRoleService,
    private ipAuthService: IpAuthService,
    private profileService: IpProfileService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkUserRole(next);
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canActivate(next, state);
  }

  private checkUserRole(route: ActivatedRouteSnapshot): boolean {
    const token = this.ipAuthService.getToken();
    if (!token) {
      this.router.navigateByUrl('invopay/admin/login-admin')
      return false
    }
    const allowedRoles = route.data['allowedRole'] as string[];
    
    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }
    
    if (this.profileService.enterpriseMeuConfig.length > 0 && !allowedRoles.includes('all')){
      if (allowedRoles.some(item => this.profileService.enterpriseMeuConfig.some(menu=>menu === item)))
        return this.checkRole(allowedRoles);
      else {
        this.router.navigateByUrl('invopay/admin/home')
        return false
      } 
    }    

    return this.checkRole(allowedRoles);
  }  
  
  private checkRole(allowedRoles: string[]): boolean{
    const userType = this.ipRoleService.getType();
      if (allowedRoles.includes(userType)) {
        const type = this.ipRoleService.getUserType();
        if (userType === 'business' && type !== 'ENTERPRISE_ADMIN' && type !== 'ENTERPRISE_MANAGER'){
          const permission = this.ipAuthService.getUserRole()?.permissions
          if (allowedRoles.some(item => permission?.some(per=>per.name === item)))
            return true;
          else {
            this.router.navigateByUrl('invopay/admin/home')
            return false
          } 
        }
        return true;
      }
    this.router.navigate(['/invopay/admin/home']);
    return false;
  }
}

